import { Nullable, RecursiveStatic } from '@diamond/shared/schema';
import { Type } from '@sinclair/typebox';

export const ShiptoDepositPeriodSchema = Type.Union(
  [
    Type.Literal('1m'),
    Type.Literal('3m'),
    Type.Literal('6m'),
    Type.Literal('all'),
  ],
  { default: 'all' }
);

export const ShiptoDepositMovementTypeSchema = Type.Union([
  Type.Literal('credit_shipto'),
  Type.Literal('debit_shipto'),
]);

const WarehouseQuerySchema = Type.Object({
  warehouse: Type.String({ format: 'uuid', minLength: 36 }),
});

const TransactionHistoryPaginationSchema = Type.Object({
  page: Type.Integer({ minimum: 1 }),
  size: Type.Integer({ minimum: 1, maximum: 100 }),
  rows: Type.Integer({ minimum: 0 }),
  pages: Type.Integer({ minimum: 0 }),
});

export const ShiptoDepositCrudSchema = {
  path: '/shipto-deposit',

  getBalance: {
    path: '/balance',
    query: WarehouseQuerySchema,
    response: Type.Object({
      sap_no_shipto: Type.Integer(),
      available_balance: Type.Integer({ minimum: 0 }),
      last_updated_at: Nullable(Type.String({ format: 'date-time' })),
    }),
  },

  getTransactionHistories: {
    path: '/transaction-histories',
    query: Type.Intersect([
      WarehouseQuerySchema,
      Type.Object({
        period: Type.Optional(ShiptoDepositPeriodSchema),
        page: Type.Optional(Type.Integer({ minimum: 1, default: 1 })),
        size: Type.Optional(
          Type.Integer({ minimum: 1, maximum: 100, default: 50 })
        ),
      }),
    ]),
    response: Type.Object({
      data: Type.Array(
        Type.Object({
          id: Type.String({ format: 'uuid' }),
          transaction_at: Type.String({ format: 'date-time' }),
          po_number: Type.String(),
          sub_po_number: Nullable(Type.String()),
          so_number: Nullable(Type.String()),
          movement_type: ShiptoDepositMovementTypeSchema,
          transfer_amount: Type.Integer({ minimum: 0 }),
          final_billing_amount: Type.Integer({ minimum: 0 }),
          amount: Type.Integer({ minimum: 0 }),
          cancel_reason: Nullable(Type.String()),
        })
      ),
      pagination: TransactionHistoryPaginationSchema,
    }),
  },
};

export type ShiptoDepositCrud = RecursiveStatic<typeof ShiptoDepositCrudSchema>;
